import { axiosInstance, API_PREFIX, type ApiResponse, type RequestParams } from '@/shared/api';
import type {
  UserMe,
  UserBase,
  UserById,
  UserCreatePayload,
  UserUpdatePayload,
  UpdateCredentialsPayload,
  AdminUpdateCredentialsPayload,
  ContentMaker,
  ContentMakerDetail,
  ContentMakerDetailParams,
  ContentMakersParams,
  UserByType,
  UsersByTypeParams,
} from '../model/types';
import type { ApiResponseList } from '@/shared/api/types';

export const userApi = {
  getMe: async (): Promise<ApiResponse<UserMe>> => {
    const { data } = await axiosInstance.get<ApiResponse<UserMe>>(`${API_PREFIX.ADMIN_V1}/auth/user-me`);
    return data;
  },

  getList: async (params?: RequestParams): Promise<ApiResponseList<UserBase>> => {
    const { data } = await axiosInstance.get<ApiResponseList<UserBase>>(`${API_PREFIX.ADMIN_V1}/user/index`, {
      params,
    });
    return data;
  },

  getById: async (id: number): Promise<ApiResponse<UserById>> => {
    const { data } = await axiosInstance.get<ApiResponse<UserById>>(`${API_PREFIX.ADMIN_V1}/user/show`, {
      params: { id },
    });
    return data;
  },

  create: async (payload: UserCreatePayload): Promise<ApiResponse<UserById>> => {
    const { data } = await axiosInstance.post<ApiResponse<UserById>>(`${API_PREFIX.ADMIN_V1}/user/create`, payload);
    return data;
  },

  update: async (payload: UserUpdatePayload): Promise<ApiResponse<UserById>> => {
    const { data } = await axiosInstance.post<ApiResponse<UserById>>(`${API_PREFIX.ADMIN_V1}/user/update`, payload);
    return data;
  },

  remove: async (id: number): Promise<ApiResponse<null>> => {
    const { data } = await axiosInstance.post<ApiResponse<null>>(`${API_PREFIX.ADMIN_V1}/user/delete`, { id });
    return data;
  },

  updateCredentials: async (payload: UpdateCredentialsPayload): Promise<ApiResponse<UserMe>> => {
    const { data } = await axiosInstance.post<ApiResponse<UserMe>>(
      `${API_PREFIX.ADMIN_V1}/user/update-credentials`,
      payload
    );
    return data;
  },

  adminUpdateCredentials: async (payload: AdminUpdateCredentialsPayload): Promise<ApiResponse<UserById>> => {
    const { data } = await axiosInstance.post<ApiResponse<UserById>>(
      `${API_PREFIX.ADMIN_V1}/user/admin-update-credentials`,
      payload
    );
    return data;
  },

  getContentMakers: async (params?: ContentMakersParams): Promise<ApiResponse<ContentMaker[]>> => {
    const { data } = await axiosInstance.get<ApiResponse<ContentMaker[]>>(
      `${API_PREFIX.ADMIN_V1}/users/content-makers`,
      { params }
    );
    return data;
  },

  getUsersByType: async (params: UsersByTypeParams): Promise<ApiResponseList<UserByType>> => {
    const { data } = await axiosInstance.get<ApiResponseList<UserByType>>(`${API_PREFIX.ADMIN_V1}/users/list-by-type`, {
      params,
    });
    return data;
  },

  getContentMakerById: async (params: ContentMakerDetailParams): Promise<ApiResponseList<ContentMakerDetail>> => {
    const { data } = await axiosInstance.get<ApiResponseList<ContentMakerDetail>>(
      `${API_PREFIX.ADMIN_V1}/users/content-makers/added-products-list`,
      { params }
    );
    return data;
  },
};
